import * as XLSX from 'xlsx-js-style';

export const ChildReportExcell = (children, school, cols, subHeaders, commonAdvantages, advantages) => {
    const headers = [];
    const mergeRanges = [];

    for (var i = 0; i < commonAdvantages.length; i++) {
        headers.push({ title: `П${commonAdvantages[i].id} - ${commonAdvantages[i].name}`, cellAddress: `A${i + 1}` })
    }

    for (var i = 0; i < advantages.length; i++) {
        headers.push({ title: `П${advantages[i].id} - ${advantages[i].name}` , cellAddress: `A${commonAdvantages.length + i + 1}` })
    }

    const sumAdv = commonAdvantages.length + advantages.length;

    for (var i = 0; i < sumAdv; i++) {
        mergeRanges.push({ s: { r: i, c: 0 }, e: { r: i, c: 3 } },)
    }

    debugger
    const workSheet = XLSX.utils.json_to_sheet(children, { origin: `A${sumAdv + 2}`, skipHeader: false, cellStyles: true });

    for (const range of mergeRanges) {
        const result = [];
        const startRow = range.s.r;
        const endRow = range.e.r;
        const startColumn = range.s.c;
        const endColumn = range.e.c;

        for (let row = startRow; row <= endRow; row++) {
            for (let col = startColumn; col <= endColumn; col++) {
                const colLetter = XLSX.utils.encode_col(col);
                const rowEx = row + 1;
                result.push(`${colLetter}${rowEx}`);
            }
        }

        result.forEach(cell => {
            workSheet[cell] = { t: 's', v: '', s: {} }

            workSheet[cell].s = {
                font: { bold: true },
                border: borderStyle,
                
            }
        });
    }

    if (!workSheet['!merges']) {
        workSheet['!merges'] = [];
    }

    mergeRanges.forEach((range) => {
        workSheet['!merges'].push(range);
    });

    for (const header of headers) {
        applyHeader(workSheet, header.title, header.cellAddress);
    }

    workSheet['!cols'] = cols;

    const workBook = XLSX.utils.book_new()


    for (const cell in workSheet) {

        if (cell == '!ref' || cell == '!merges') {
            continue;
        }

        if (workSheet[cell]) {
            workSheet[cell].s = {
                ...workSheet[cell].s,
                border: borderStyle,
                alignment: { horizontal: "left" }
            };
        }
    }

    for (var i = 1; i <= sumAdv; i++) {
        if (workSheet[`A${i}`]) {
            workSheet[`A${i}`].s = {
                ...workSheet[`A${i}`].s,
                alignment: {...wrapTextConst },
            };
        }
    }


    XLSX.utils.book_append_sheet(workBook, workSheet, "Класирани деца")
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" })
    XLSX.writeFile(workBook, `Класирани деца - ${school}.xlsx`)
}

export const applyHeader = (workSheet, header, origin) => {
    XLSX.utils.sheet_add_json(workSheet, [{ [header]: '' }], { origin: origin, charCodes: true });
}

export const borderStyle = {
    top: { style: 'thin', color: 'black' },
    bottom: { style: 'thin', color: 'black' },
    left: { style: 'thin', color: 'black' },
    right: { style: 'thin', color: 'black' },
};

export const centerAlign = {
    horizontal: 'center',
    vertical: 'center',
};

export const wrapTextConst = {
    wrapText: true
};